import type { VoidFunctionComponent } from 'react';

import Link from '../../generic/Link';

import styles from './FossabotInlineTip.module.less';

const FossabotInlineTip: VoidFunctionComponent = () => (
  <div className={styles.tip}>
    <span className={styles.iconWrapper} aria-hidden>
      <img src="/img/fossabot-logo-color.svg" alt="" />
    </span>
    <span className={styles.text}>
      Test drive <strong>fossabot</strong> to find breaking changes that affect your app.
      {' '}
      <Link to="https://fossa.com/products/fossabot/?utm_source=fossa-scan&utm_medium=web&utm_campaign=issue-remediate" openInNewTab>
        Learn more
      </Link>
    </span>
  </div>
);

export default FossabotInlineTip;
